import Api from "./Api";
import { API_VERSION } from "@/config/index";

export default {
  GetAllBookings(payload) {
    let query = "";
    if (payload.search) {
      query += `?search=${payload.search}`;
    }
    return Api().get(
      `/${API_VERSION}/webapp/profile/bookings/${query}`,
      payload
    );
  },
  GetAllItemsBookings(payload) {
    return Api().get(`/${API_VERSION}/webapp/profile/bookings/items`, payload);
  },
  //   GetProfileDetails(payload) {
  //     return Api().get(`/${API_VERSION}/webapp/profile`, payload);
  //   },
  EditProfileDetails(payload) {
    return Api().put(`/${API_VERSION}/webapp/profile`, payload);
  },
  GetUnreadNotificationsCount(payload) {
    return Api().get(
      `/${API_VERSION}/webapp/profile/unread-notification-count`,
      payload
    );
  },
  MarkUnreadNotificationsRead(payload) {
    return Api().put(
      `/${API_VERSION}/webapp/profile/mark-all-notifications-read`,
      payload
    );
  },
  UpdateProfileImage(payload) {
    return Api().put(`/${API_VERSION}/webapp/profile/image`, payload);
  }
};



// WEBPACK FOOTER //
// ./src/apiServices/ProfileService.js